import { render, staticRenderFns } from "./MenuBarPortal.vue?vue&type=template&id=91f83fae&scoped=true"
import script from "./MenuBarPortal.vue?vue&type=script&lang=js"
export * from "./MenuBarPortal.vue?vue&type=script&lang=js"
import style0 from "./MenuBarPortal.vue?vue&type=style&index=0&id=91f83fae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f83fae",
  null
  
)

export default component.exports